// Keep asset URLs in Liquid so imports follow the published theme and CDN versions.
const config = document.getElementById('optional-components');

if (config) {
  const components = JSON.parse(config.textContent).map((component) => ({
    ...component,
    elements: new WeakSet(),
    promise: null,
    loaded: false,
  }));

  const loadWithin = (root) => {
    for (const component of components) {
      // Custom elements upgrade automatically, and stock alerts use delegated events.
      if (component.loaded && !component.initialize) continue;

      const elements = [...root.querySelectorAll(component.selector)];
      if (root instanceof Element && root.matches(component.selector)) elements.unshift(root);

      for (const element of elements) {
        if (component.elements.has(element)) continue;
        component.elements.add(element);

        component.promise ??= import(component.src);
        component.promise
          .then((module) => {
            component.loaded = true;
            if (component.initialize) module[component.initialize](element);
          })
          .catch((error) => {
            component.elements.delete(element);
            console.error(`Unable to initialise optional component: ${component.selector}`, error);
          });
      }
    }
  };

  // Section rendering, quick-add and the theme editor can insert components later.
  // Only inspect added subtrees; do not rescan the entire page on each mutation.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) loadWithin(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  loadWithin(document);
}
